import React from "react";
import moment from "moment";
import { quitarClaveNombre } from "../../utils/destajos";
import { soloComentario } from "../../utils";
import TextoExpandible from "../common/TextoExpandible";

const formatDeletedAt = (value) =>
  value ? moment(value).format("DD MMM YYYY HH:mm") : "-";

const EliminadoCard = ({
  clave,
  nombre,
  partida,
  partidaEliminada,
  deletedAt,
  eliminadoPor,
  comentario,
  onRestore,
}) => {
  const texto = soloComentario(comentario);

  return (
    <div className="card border shadow-sm mb-3" style={{ borderRadius: 10 }}>
      <div className="card-body p-3">
        <div className="d-flex align-items-start">
          <div className="flex-grow-1" style={{ minWidth: 0 }}>
            <TextoExpandible>
              {clave && <span className="text-muted me-1">[{clave}]</span>}
              <span className="bold">{quitarClaveNombre(nombre, clave)}</span>
            </TextoExpandible>
            {partida && (
              <div className="small text-muted">
                <i className="fa fa-folder me-1" />
                {partida}
                {partidaEliminada && (
                  <span className="badge bg-danger ms-2">Partida eliminada</span>
                )}
              </div>
            )}
          </div>
          <button
            className="btn btn-sm btn-outline-primary ms-3 text-nowrap"
            onClick={onRestore}
          >
            <i className="fa fa-undo me-1" /> Restaurar
          </button>
        </div>
        <div className="small text-muted mt-2">
          <i className="fa fa-trash me-1" />
          {formatDeletedAt(deletedAt)}
          {eliminadoPor && <> · {eliminadoPor}</>}
        </div>
        {texto && (
          <div
            className="small mt-2 p-2 rounded bg-light"
            style={{ borderLeft: "3px solid var(--primary)" }}
          >
            <i className="fa fa-comment text-muted me-1" />
            {texto}
          </div>
        )}
      </div>
    </div>
  );
};

export default EliminadoCard;
